var app = angular.module('app-registration', ['app-account-service', 'app-cart-service', 'app-helpers', 'naif.base64']);

app.controller('Registration', ['$scope', 'helpers', '$http', '$window', '$q', 'accountService', '$sce', 'cartService', function ($scope, helpers, $http, $window, $q, accountService, $sce, cartService) {
    $scope.Registration = [];
    $scope.base64Object = [];
    $scope.fileResizeLoading = false;
    $scope.showPersonalData = false;
    $scope.isGiantIdGuest = false;
    $scope.guestToken = '';
    $scope.guestVerificationCode = '';
    $scope.guestEmailVerified = false;
    $scope.guestVerificationCodeSent = false;
    $scope.containsValidAddress = true;
    $scope.GiantConnect = false;
    $scope.errorRegistration = '';

    $scope.Login = function () {
        accountService.Login($scope.loginEmail, $scope.loginPassword, true, true).then(function () {
            if (accountService._account.result != null && accountService._account.result.Token != null && accountService._account.result.Token.length > 0 && accountService._account.result.Details != undefined) {
                $scope.Registration.Registration.Gender = accountService._account.result.Details.GenderToFormat;
                $scope.Registration.Registration.FirstName = accountService._account.result.Details.OrderFirstname;
                $scope.Registration.Registration.LastName = accountService._account.result.Details.OrderLastname;
                $scope.Registration.Registration.Address = accountService._account.result.Details.OrderStreet;
                $scope.Registration.Registration.PostalCode = accountService._account.result.Details.OrderPostalcode;
                $scope.Registration.Registration.City = accountService._account.result.Details.OrderCity;
                $scope.Registration.Registration.State = accountService._account.result.Details.OrderState;
                $scope.Registration.Registration.Phone = accountService._account.result.Details.OrderPhone;
                $scope.Registration.Registration.Email = accountService._account.result.Details.OrderEmail;
                $scope.Registration.Registration.BirthDateToFormat = accountService._account.result.Details.BirthDateToFormat;
                $scope.Registration.Registration.AxaptaConsumerAccountNumber = accountService._account.result.Details.OrderAxaptaConsumerAccountNumber;
                $scope.Registration.Registration.AddToNewsletter = accountService._account.result.Details.OrderAddToNewsletter;
                $scope.showPersonalData = true;
                $scope.Registration.UserAlreadyExists = false;
                $scope.validateAddress();

                //GA4
                trackEventGlobalAndLocalGA4({ 'ga4_name': 'login' , 'ga4_location': 'registration' });

            } else {
                $scope.errorLogin = accountService._account.error;

                // Find e-mail input field 
                var emailInputField = document.getElementById('Email');
                emailInputField.focus();
            }
        });
    }

    $scope.Logout = function () {
        //GA4
        trackEventGlobalAndLocalGA4({ 'ga4_name': 'logout', 'ga4_location': 'registration' });

        accountService.Logout();
    }

    $scope.sendGuestEmailVerificationCode = function () {
        $scope.errorContactInfo = '';
        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/registration/sendguestemailverificationcode';
            $http({
                method: 'POST',
                url: url,
                data: $.param({ email: $scope.Registration.Registration.Email }),
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                withCredentials: true
            }).then(function (res) {
                $scope.btnSubmitContactInfo = false;
                if (res.data.Result == true) {
                    $scope.guestVerificationCodeSent = true;
                } else {
                    $scope.errorContactInfo = res.data.ErrorMessage || 'An error occured. Please try again';
                }
            }, function () {
                $scope.btnSubmitContactInfo = false;
                $scope.errorContactInfo = 'An error occured. Please try again';
            });
        });
    };

    $scope.validateGuestEmailVerificationCode = function () {
        $scope.errorContactInfo = '';
        $scope.btnSubmitContactInfo = true;
        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/registration/validateguestemailverificationcode';
            $http({
                method: 'POST',
                url: url,
                data: $.param({
                    email: $scope.Registration.Registration.Email,
                    verificationCode: $scope.guestVerificationCode
                }),
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                withCredentials: true
            }).then(function (res) {
                if (res.data.Result == true && res.data.GuestToken) {
                    $scope.guestToken = res.data.GuestToken;
                    $scope.guestEmailVerified = true;
                    $scope.getGeolocation(function () { setcontactInfo() });
                } else {
                    $scope.btnSubmitContactInfo = false;
                    $scope.errorContactInfo = res.data.ErrorMessage || 'invalid guest token';
                }
            }, function () {
                $scope.btnSubmitContactInfo = false;
                $scope.errorContactInfo = 'An error occured. Please try again';
            });
        });
    };

    $scope.$watch('Registration.Registration.Email', function (newValue, oldValue) {
        if ($scope.isGiantIdGuest && oldValue && newValue !== oldValue) {
            $scope.guestToken = '';
            $scope.guestVerificationCode = '';
            $scope.guestEmailVerified = false;
            $scope.guestVerificationCodeSent = false;
        }
    });

    $scope.uploadReceipt = function () {
        $('#filestyle-0').trigger('click');
        $scope.fileResizeLoading = true;
    }

    $scope.resizeImage = function (file, base64_object) {
        //https://github.com/adonespitogo/angular-base64-upload
        //https://github.com/oliver-moran/jimp
        // file is an instance of File constructor.
        // base64_object is an object that contains compiled base64 image data from file.
        $scope.fileResizeLoading = true;
        $scope.errorRegistration = '';
        $scope.$apply();

        if (file.type != 'application/pdf' && file.type != 'image/jpeg' && file.type != 'image/png') {
            $scope.fileResizeLoading = false;
            $scope.errorRegistration = 'Not a valid file type';
            $scope.$apply();
            return;
        } else {

            //pdf
            if (file.type == 'application/pdf') {
                // Select the very first file from list
                var fileToLoad = file;
                // FileReader function for read the file.
                var fileReader = new FileReader();
                var base64;
                // Onload of file read the file content
                fileReader.onload = function (fileLoadedEvent) {
                    base64 = fileLoadedEvent.target.result;
                    var bytes = Math.round((3 / 4) * base64.length);
                    $scope.base64Object.filetype = file.type;
                    $scope.base64Object.filesize = bytes;
                    $scope.base64Object.filename = file.name;
                    $scope.base64Object.base64 = base64;
                    $scope.base64Object.base64Replaced = base64.replace('data:application/pdf;base64,', '');
                    // Note that base64 in this package doesn't contain "data:image/jpeg;base64," part,
                    // while base64 string from Jimp does. It should be taken care of in back-end side.
                    $scope.fileResizeLoading = false;
                    $scope.$apply();
                    //deferred.resolve($scope.base64Object);
                    return;
                };
                // Convert data to base64
                fileReader.readAsDataURL(fileToLoad);
            } else {
                //image
                var deferred = $q.defer();
                var url = URL.createObjectURL(file);// creates url for file object.
                Jimp.read(url)
                    .then(function (item) {
                        item
                            .resize(800, Jimp.AUTO)// width of 1280px, auto-adjusted height
                            .quality(50)//drops the image quality to 50%
                            .getBase64(file.type, function (err, newBase64) {
                                if (err) { throw err; }
                                var bytes = Math.round((3 / 4) * newBase64.length);

                                // Verwijder de prefix 'data:image/gif;base64,' (of de juiste MIME-type voor jouw afbeelding)
                                const base64Data = newBase64.split(',')[1];

                                // Zet de base64 string om naar bytes (Uint8Array)
                                //const byteArray = Uint8Array.from(atob(base64Data), c => c.charCodeAt(0));

                                $scope.base64Object.filetype = file.type;
                                $scope.base64Object.filesize = bytes;
                                $scope.base64Object.filename = file.name;
                                $scope.base64Object.base64 = newBase64;
                                $scope.base64Object.base64Replaced = base64Data;
                                // Note that base64 in this package doesn't contain "data:image/jpeg;base64," part,
                                // while base64 string from Jimp does. It should be taken care of in back-end side.
                                $scope.fileResizeLoading = false;
                                $scope.$apply();
                                deferred.resolve($scope.base64Object);
                            });
                    })
                    .catch(function (err) {
                        $scope.fileResizeLoading = false;
                        $scope.$apply();
                        return console.log(err);// error handling
                    });
                return deferred.promise;
            }
        }
    };

    $scope.reset = function () {
        var serial = $scope.Registration.Registration.SerialNumber;
        $scope.Registration = [];
        $scope.Registration.Registration = [];
        $scope.Registration.Registration.SerialNumber = serial;
        $scope.isValidSelectBike = false;
        $scope.isValidContactInfo = false;
        $scope.isValidPointOfPurchase = false;
    }

    $scope.collapseIsAuthorizedToEdit = function (collapseName) {
        //Check of this collapse block can be opened when previous collapse blocks are valid
        switch (collapseName) {
            case 'selectbike':
                return true;
            case 'contactinfo':
                return $scope.collapseIsValid('selectbike');
            case 'pointofpurchase':
                return $scope.collapseIsValid('contactinfo') && $scope.collapseIsValid('selectbike');
            case 'purchasedate':
                return $scope.collapseIsValid('contactinfo') && $scope.collapseIsValid('selectbike') && $scope.collapseIsValid('pointofpurchase');
            case 'confirmation':
                return $scope.collapseIsValid('contactinfo') && $scope.collapseIsValid('selectbike') && $scope.collapseIsValid('pointofpurchase') && $scope.collapseIsValid('purchasedate');
            default:
                return false;
        }
    }

    $scope.collapseIsValid = function (collapseName) {
        //Check of all required fields have been set
        switch (collapseName) {
            case 'selectbike':
                return $scope.isValidSelectBike;
            case 'contactinfo':
                return $scope.isValidContactInfo;
            case 'pointofpurchase':
                return $scope.isValidPointOfPurchase;
            case 'purchasedate':
                return $scope.isValidPurchaseDate;
            case 'confirmation':
                return $scope.isValidConfirmation;
            default:
                return false;
        }
    }

    //Step 1
    $scope.proceedSelectBike = function (selectLocknumber) {
        //check required fields
        $scope.errorSelectBike = '';
        $scope.file = [];
        $scope.proceedSelectBikeButtonClicked = true;
        if ($scope.formSelectBike.$valid) {
            grecaptcha.ready(function () {
                grecaptcha.execute(window.GoogleRecaptchaSiteKey, { action: 'social' })
                    .then(function (token) {
                        cartService.MasterDomain().then(function () {
                            var url = cartService._masterDomain + '/' + $window.culture + '/registration/findBike';
                            $http({
                                method: 'POST',
                                url: url,
                                data: { serialNumber: $scope.Registration.Registration.SerialNumber, lockNumber: $scope.Registration.Registration.LockNumber != undefined ? $scope.Registration.Registration.LockNumber : null, token: token, guid: $scope.Registration.Registration.Guid },
                                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                                transformRequest: function (obj) {
                                    //Deze transformatie is nodig icm Content-Type anders krijg je een 404 preflight error (http://stackoverflow.com/questions/24710503/how-do-i-post-urlencoded-form-data-with-http-in-angularjs)
                                    var str = [];
                                    for (var p in obj)
                                        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                                    return str.join("&");
                                },
                                withCredentials: true
                            }).then(function (res) {
                                if (res.data.Result == true) {
                                    $scope.Registration = res.data;
                                    $scope.isValidSelectBike = true;
                                    if (res.data.Registration.HasLockNumber == false || (selectLocknumber != undefined && selectLocknumber == true)) {
                                        //show and focus
                                        $('#collapseContactInfo').collapse('show');
                                        $('#collapseContactInfo input#Email').focus();
                                        // hide
                                        $('#collapseSelectBike').collapse('hide');
                                    }
                                    if ($scope.Registration.Registration.AxaptaConsumerAccountNumber != null && $scope.Registration.Registration.AxaptaConsumerAccountNumber.length > 0) {
                                        $scope.showPersonalData = true;
                                    }
                                    if ($scope.Registration.Registration.GiantID != null && $scope.Registration.Registration.GiantID.length > 0) {
                                        $scope.showPersonalData = true;
                                    }
                                } else {
                                    $scope.errorSelectBike = res.data.ErrorMessage;
                                    $scope.Registration = res.data;
                                }
                                $scope.proceedSelectBikeButtonClicked = false;
                            });
                        });
                    });
            });
        } else {
            if ($scope.formSelectBike.$error.required != undefined && $scope.formSelectBike.$error.required.length > 0) {
                $scope.errorSelectBike += lblMakeSureAllRequiredFieldsAreEntered;
                angular.element('input.ng-invalid').first().focus();
            }
        }
    }

    //Step 2
    $scope.proceedContactInfo = function () {
        //check required fields
        $scope.errorContactInfo = '';
        $scope.isOrderPhoneInvalid = false;
        $scope.btnSubmitContactInfo = true;
        if ($scope.formContactInfo.$valid) {
            if (!helpers.isValidOrderPhone($scope.Registration.Registration.Phone)) {
                $scope.isOrderPhoneInvalid = true;
                $scope.errorContactInfo = window.orderPhoneValidationMessage || 'Phone number is incorrect';
                $scope.btnSubmitContactInfo = false;
                angular.element('#Phone').focus();
                return;
            }

            if ($scope.isGiantIdGuest && !$scope.guestEmailVerified) {
                if ($scope.guestVerificationCodeSent) {
                    $scope.errorContactInfo = 'Please enter the verification code sent to your email.';
                    $scope.btnSubmitContactInfo = false;
                    return;
                }

                $scope.sendGuestEmailVerificationCode();
                return;
            }

            if (window.validateAddressAtLoqate != undefined && window.validateAddressAtLoqate == true) {
                helpers.validateAddress($scope.Registration.Registration.Address, $scope.Registration.Registration.PostalCode, $scope.Registration.Registration.City, $scope.Registration.Registration.Email, $scope.Registration.Registration.Phone, $scope.Registration.Registration.State, $scope.LoqateKey,false,
                    function () {
                        $scope.getGeolocation(function () { setcontactInfo() });
                    },
                    function (address) {
                        $scope.btnSubmitContactInfo = false;
                        $('#Address').val(address.Line1);
                        $('#Postalcode').val(address.PostalCode);
                        $('#City').val(address.City);
                        $('#State').val(address.Province);
                        $scope.Registration.Registration.Address = address.Line1;
                        $scope.Registration.Registration.PostalCode = address.PostalCode;
                        $scope.Registration.Registration.City = address.City;
                        $scope.Registration.Registration.State = address.Province;
                        $scope.$apply();
                    },
                    function (data) {
                        $scope.btnSubmitContactInfo = false;

                        if (data != undefined) {
                            if (data.PhoneToFormat != null && data.PhoneToFormat.length > 0) {
                                $('#Phone').val(data.PhoneToFormat);
                                $scope.Registration.Registration.Phone = data.PhoneToFormat;
                            }
                        }
                    }
                );
            } else {
                $scope.getGeolocation(function () { setcontactInfo() });
            }
          

        } else {
            if ($scope.formContactInfo.$error.required != undefined && $scope.formContactInfo.$error.required.length > 0) {
                $scope.errorContactInfo += lblMakeSureAllRequiredFieldsAreEntered;
                angular.element('input.ng-invalid').first().focus();
            } else {
                $scope.errorContactInfo += 'An error occured. Please try again';
                $scope.btnSubmitContactInfo = false;
            }
        }
    }

    var setcontactInfo = function () {
        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/registration/saveContact?source=contactInfo&createUser=true';
            $http({
                method: 'POST',
                url: url,
                data: $('#formContactInfo').serialize(),
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                withCredentials: true
            }).then(function (res) {
                if (res.data.Result == true) {
                    $scope.Registration = res.data;
                    $scope.isValidContactInfo = true;
                    // hide
                    $('#collapseContactInfo').collapse('hide');
                    if ($scope.Registration.Registration.ReceivedDealerFromAxapta == false) {
                        $scope.dealercity = $scope.Registration.Registration.Address + ' ' + $scope.Registration.Registration.PostalCode + ' ' + $scope.Registration.Registration.City;
                        $scope.getGeolocationAndGetDealers(function () {
                            $('#collapsePointOfPurchase').collapse('show');
                            $('#collapsePointOfPurchase input:checkbox').focus();
                        });
                    } else {
                        $('#collapsePointOfPurchase').collapse('show');
                        $('#collapsePointOfPurchase input:checkbox').focus();
                    }
                } else {
                    if (res.data.UserAlreadyExists == true) {
                        $scope.Registration.UserAlreadyExists = true;
                    } else {
                        $scope.isOrderPhoneInvalid = !helpers.isValidOrderPhone($scope.Registration.Registration.Phone);
                        $scope.errorContactInfo = res.data.ErrorMessage;
                    }
                }
                $scope.btnSubmitContactInfo = false;
            });
        });
    };

    //Step 3a
    $scope.proceedPointOfPurchase = function () {
        //check required fields
        $scope.errorPointOfPurchase = '';
        $scope.btnSubmitPointOfPurchase = true;
        if ($scope.formPointOfPurchase.$valid) {
            cartService.MasterDomain().then(function () {
                var url = cartService._masterDomain + '/' + $window.culture + '/registration/saveContact?source=pointOfPurchase';
                $http({
                    method: 'POST',
                    url: url,
                    data: $('#formContactInfo').serialize(),
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    withCredentials: true
                }).then(function (res) {
                    if (res.data.Result == true) {
                        $scope.Registration = res.data;
                        $scope.isValidPointOfPurchase = true;
                        $('#collapsePointOfPurchase').collapse('hide');
                        $('#collapsePurchaseDate').collapse('show');
                    } else {
                        $scope.errorPointOfPurchase = res.data.ErrorMessage;
                    }
                    $scope.btnSubmitPointOfPurchase = false;
                });
            });
        } else {
            if ($scope.formPointOfPurchase.$error.required != undefined && $scope.formPointOfPurchase.$error.required.length > 0) {
                $scope.errorPointOfPurchase += lblMakeSureAllRequiredFieldsAreEntered;
                angular.element('input.ng-invalid').first().focus();
            }
        }
    }

    //Step 3b
    $scope.proceedSelectDealer = function (dealer) {
        $('#hiddenDealerCode').val(dealer.Code);
        $scope.errorPointOfPurchase = '';
        $scope.btnSubmitPointOfPurchase = true;
        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/registration/saveContact?source=selectDealer';
            $http({
                method: 'POST',
                url: url,
                data: $('#formContactInfo').serialize(),
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                withCredentials: true
            }).then(function (res) {
                if (res.data.Result == true) {
                    $scope.Registration = res.data;
                    $scope.isValidPointOfPurchase = true;
                    $('#collapsePointOfPurchase').collapse('hide');
                    $('#collapsePurchaseDate').collapse('show');
                } else {
                    $scope.errorPointOfPurchase = res.data.ErrorMessage;
                }
                $scope.btnSubmitPointOfPurchase = false;
            });
        });
    }

    //Step 4
    $scope.proceedPurchaseDate = function () {
        //check required fields
        $scope.errorPurchaseDate = '';
        $scope.btnSubmitPurchaseDate = true;
        if ($scope.formPurchaseDate.$valid) {
            cartService.MasterDomain().then(function () {
                var url = cartService._masterDomain + '/' + $window.culture + '/registration/saveContact?source=purchaseDate';
                $http({
                    method: 'POST',
                    url: url,
                    data: $('#formContactInfo').serialize(),
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    withCredentials: true
                }).then(function (res) {
                    if (res.data.Result == true) {
                        $scope.Registration = res.data;
                        $scope.isValidPurchaseDate = true;
                        // hide
                        $('#collapsePurchaseDate').collapse('hide');
                        // show and focus
                        $('#collapseConfirmation').collapse('show');
                        $('#collapseConfirmation button.btn-proceed').focus();
                    } else {
                        $scope.errorPurchaseDate = res.data.ErrorMessage;
                    }
                    $scope.btnSubmitPurchaseDate = false;
                });
            });
        } else {
            if ($scope.formPurchaseDate.$error.required != undefined && $scope.formPurchaseDate.$error.required.length > 0) {
                $scope.errorPurchaseDate += lblMakeSureAllRequiredFieldsAreEntered;
                angular.element('input.ng-invalid').first().focus();
            }
        }
    }

    //Step 5
    $scope.proceedConfirmation = function () {
        //check required fields
        $scope.errorConfirmation = '';
        $scope.btnSubmitConfirmation = true;
        if ($scope.formConfirmation.$valid) {
            cartService.MasterDomain().then(function () {
                var url = cartService._masterDomain + '/' + $window.culture + '/registration/saveContact?source=confirmation&confirm=true';
                $http({
                    method: 'POST',
                    url: url,
                    data: $('#formContactInfo').serialize(),
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    withCredentials: true
                }).then(function (res) {
                    if (res.data.Result == true) {
                        $scope.Registration = res.data;
                        $scope.isValidConfirmation = true;
                        $('#collapseConfirmation').collapse('hide');

                        //GA4
                        trackEventGlobalAndLocalGA4({ 'ga4_name': 'bike_registration', 'ga4_point_of_purchase': $scope.Registration.Dealer.Name, 'ga4_model_category': $scope.Registration.GA_category, 'ga4_model_name': $scope.Registration.Product.Name, 'ga4_purchase_date': ($scope.Registration.Registration.BuyDateISO != null ? $scope.Registration.Registration.BuyDateISO.replace('-', '').replace('-', '') : '') });

                        //push email to klaviyo
                        var preferences = $.gdprcookie.preference();
                        if (preferences.indexOf('statistics') > -1 && preferences.indexOf('marketing') > -1 && res.data.hasKlaviyoSubscription != null && res.data.hasKlaviyoSubscription == true) {
                            klaviyo.push(['identify', {
                                // Change the line below to dynamically print the user's email.
                                '$email': res.data.Registration.Email
                            }]);

                            //send registration to Klaviyo
                            try {
                                waitUntilElementLoad('klaviyo', 1000, function () {
                                    klaviyo.push(["track", "Product Registered", {
                                        "City": $scope.Registration.Registration.City,
                                        "Zipcode": $scope.Registration.Registration.PostalCode,
                                        "Point of Purchase": $scope.Registration.Registration.PointOfPurchaseLocationDescription,
                                        "Date of Purchase": $scope.Registration.Registration.BuyDateISO,
                                        "Product Name": $scope.Registration.Product.Name,
                                    }]);
                                    log('klaviyo sent Product Registered');
                                }, function () {
                                    if ($.gdprcookie.hasPreferences()) {
                                        var preferences = $.gdprcookie.preference();
                                        if (preferences.indexOf('statistics') == -1 || preferences.indexOf('marketing') == -1) {
                                            return true;
                                        }
                                    }
                                    return false;
                                });
                            } catch (e) {
                            }
                        }
                    } else {
                        $scope.errorConfirmation = res.data.ErrorMessage;
                    }
                    $scope.btnSubmitConfirmation = false;
                });
            });
        } else {
            if ($scope.formConfirmation.$error.required != undefined && $scope.formConfirmation.$error.required.length > 0) {
                $scope.errorConfirmation += lblMakeSureAllRequiredFieldsAreEntered;
                angular.element('input.ng-invalid').first().focus();
            }
        }
    }

    $scope.showWilmarModal = function () {
        $('#wilmarModal').modal('show');
    }

    $scope.initWilmar = function () {
        $scope.errorInitWilmar = '';
        $scope.proceedInitWilmarButtonClicked = true;
        if ($scope.wilmarEmail.length > 0 && getParameterByName('p') != null && getParameterByName('p').length > 0) {
            cartService.MasterDomain().then(function () {
                var url = cartService._masterDomain + '/' + $window.culture + '/registration/initWilmar';
                $http({
                    method: 'POST',
                    url: url,
                    data: { p: getParameterByName('p'), email: $scope.wilmarEmail },
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    transformRequest: function (obj) {
                        //Deze transformatie is nodig icm Content-Type anders krijg je een 404 preflight error (http://stackoverflow.com/questions/24710503/how-do-i-post-urlencoded-form-data-with-http-in-angularjs)
                        var str = [];
                        for (var p in obj)
                            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                        return str.join("&");
                    },
                    withCredentials: true
                }).then(function (res) {
                    if (res.data.Result == true) {
                        $scope.Registration = res.data;
                        $scope.isValidSelectBike = true;
                        $scope.isValidContactInfo = true;
                        $scope.isValidPointOfPurchase = true;
                        if ($scope.Registration.Registration.BuyDateToFormat.length > 0) {
                            $scope.isValidPurchaseDate = true;
                        }
                        $('#collapseSelectBike').collapse('hide');
                        $('#collapseContactInfo').collapse('show');
                        $('#wilmarModal').modal('hide');
                        $scope.errorInitWilmar = '';
                    } else {
                        $scope.errorInitWilmar = res.data.ErrorMessage;
                    }
                    $scope.proceedInitWilmarButtonClicked = false;
                });
            });
        }
    }
     
    $scope.isPanelActive = function (panelName) {
        var scrollElement = "#" + panelName;
        return $(scrollElement).attr('aria-expanded') == 'true'
        //return angular.element(scrollElement).is(':visible');
    }

    $scope.getBrowserlocationAndGetDealers = function () {
        helpers.getBrowserLocation(function (lat, lng, dealercity) {
            $scope.latitude = lat;
            $scope.longitude = lng;
            $scope.dealercity = dealercity;
            $scope.getDealers();
        });
    }

    $scope.getGeolocationAndGetDealers = function (callback) {
        helpers.getGeolocation($scope.dealercity, function (lat, lng) {
            $scope.latitude = lat;
            $scope.longitude = lng;
            $scope.getDealers();
            if (callback) {
                callback();
            }
        });
    }

    $scope.getGeolocation = function (callback) {
        helpers.getGeolocation($scope.Registration.Registration.Address + ' ' + $scope.Registration.Registration.PostalCode + ' ' + $scope.Registration.Registration.City + ' ' + $scope.Registration.Registration.State + ' ' + window.country , function (lat, lng) {
            $scope.Latitude = lat;
            $scope.Longitude = lng;
            $scope.$apply();
            if (callback) {
                callback();
            }
        });
    };

    $scope.getDealers = function () {
        $http({
            method: 'POST',
            url: '/' + culture + '/stores/dealers',
            data: {
                latitude: $scope.latitude,
                longitude: $scope.longitude,
                keyword: $scope.dealercity
            }
        }).then(function (res) {
            $scope.dealers = res.data.dealers;
        });
    }

    $scope.parseHtml = function (html) {
        return $sce.trustAsHtml(html);
    };

    $scope.validateAddress = function () {
        if (window.inTestMode == undefined && countryId == 16 && $scope.Registration.Registration.Address.length > 0) {
            $scope.containsValidAddress = /\d/.test($scope.Registration.Registration.Address);
        }
    }

    $scope.productImage = function () {
        //try to find by partnumber
        var result = "";
        if ($scope.Registration.Product != null && $scope.Registration.Product.CloudinaryImagesToPartnumbers != null) {
            if ($scope.Registration.Product.CloudinaryImagesToPartnumbers.length > 0) {
                var cloudinaryImage = $scope.Registration.Product.CloudinaryImagesToPartnumbers.filter(function (x) { return x.PartnumberCodes.indexOf($scope.Registration.Partnumber.Code) > -1 })[0]
                if (cloudinaryImage != null) {
                    result = cloudinaryImage.CloudinaryImage.ImageUrlMain;
                }
            }
            if (result.length == 0) {
                result = $scope.Registration.Product.Image;
            }
        }
        return result;
    }

}]);

angular.element(document).ready(function () {
    try {
        var appID = document.getElementById('app-registration');
        angular.bootstrap(appID, ['app-registration']);
    } catch (e) {
        //do nothing
    }
});